import React from 'react'
import { FormattedMessage } from 'react-intl'
import dateicon from '../../../assets/icons/message-manager/date.svg';
import timeicon from '../../../assets/icons/message-manager/time.svg';
import { SIGNAGE_MEDIA } from '../../../utils/constants';

// renderCheckedLabels 辅助函数
function renderCheckedLabels(tree, checked) {
  function findNodePath(nodes, value, path = []) {
    for (const node of nodes) {
      if (node.value === value) {
        const filteredPath = [...path, node.label].filter((_, idx) => {
          const n = idx === 0 ? nodes[0] : null;
          return n ? n.value !== '-1' : true;
        });
        return filteredPath;
      }
      if (node.children) {
        const nextPath = node.value === '-1' ? path : [...path, node.label];
        const result = findNodePath(node.children, value, nextPath);
        if (result) return result;
      }
    }
    return null;
  }
  function getAllLeafValues(node) {
    if (!node.children || node.children.length === 0) return [node.value];
    let arr = [];
    for (const child of node.children) {
      arr = arr.concat(getAllLeafValues(child));
    }
    return arr;
  }
  function getDisplayCheckedLabels(tree, checked) {
    function collect(nodes, checkedSet) {
      let result = [];
      for (const node of nodes) {
        if (node.value === '-1') {
          result = result.concat(collect(node.children || [], checkedSet));
          continue;
        }
        if (node.children && node.children.length > 0) {
          const childValues = getAllLeafValues(node);
          const allChildrenChecked = childValues.every(val => checkedSet.has(val));
          if (allChildrenChecked) {
            result.push({ value: node.value, label: findNodePath(tree, node.value).join(' > ') });
          } else {
            result = result.concat(collect(node.children, checkedSet));
          }
        } else if (checkedSet.has(node.value)) {
          result.push({ value: node.value, label: findNodePath(tree, node.value).join(' > ') });
        }
      }
      return result;
    }
    const checkedSet = new Set(checked);
    return collect(tree, checkedSet);
  }
  if (!checked || checked.length === 0) return null;
  const displayLabels = getDisplayCheckedLabels(tree, checked);
  return (
    <div>
      {displayLabels.map(item => (
        <div key={item.value} className='mes-from-label-1 line-height-16 mb-4'>
          {item.label}
        </div>
      ))}
    </div>
  );
}

const OverviewPanel = ({ nodes, scheduler, receivers, signageName, isConflict }) => (
  <div className="row mt-3" style={{ maxHeight: isConflict ? 'calc(100vh - 440px)' : 'auto',overflowY: 'auto' }}>
    <div className="row">
      <label className="font-weight-600 font-size-14"><FormattedMessage id="SCHEDULE_SIGNAGE_HINT" /></label>
      <div className="col-3 mt-3"  style={{ height: isConflict ? 'calc(-660px + 100vh)' : 'auto' }}>
        <div className="w-100">
          <div className="fw-bold mb-4"><FormattedMessage id="DESTINATIONS" />:</div>
          {renderCheckedLabels(nodes, receivers)}
        </div>
      </div>
      <div className="col-3 mt-3" style={{ height: isConflict ? 'calc(-660px + 100vh)' : 'auto' }}>
        <div className="w-100">
          <div className="fw-bold mb-4"><FormattedMessage id="SIGNAGE" />:</div>
          <div>{signageName}</div>
        </div>
      </div>
      <div className="col-3 mt-3" style={{ height: isConflict ? 'calc(-660px + 100vh)' : 'auto' }}>
        <div className="w-100">
          <div className="fw-bold mb-4"><FormattedMessage id="DATE_AND_TIME" />:</div>
          <div className="d-flex align-items-center mb-4">
            <img src={dateicon} className="me-2 icon-20" />
            {scheduler.startingTime && scheduler.endingTime
              ? `${scheduler.startingTime instanceof Date ? scheduler.startingTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true }) : ''} - ${scheduler.endingTime instanceof Date ? scheduler.endingTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true }) : ''}`
              : ''}
          </div>
          <div className="d-flex align-items-center">
            <img src={timeicon} style={{ marginLeft: '3px' }} className="me-2 icon-20" />
            {scheduler.startingDate && scheduler.endingDate
              ? `${scheduler.startingDate instanceof Date ? scheduler.startingDate.toLocaleDateString('en-US') : ''} - ${scheduler.endingDate instanceof Date ? scheduler.endingDate.toLocaleDateString('en-US') : ''}`
              : ''}
          </div>
        </div>
      </div>
      <div className="col-3 mt-3" style={{ height: isConflict ? 'calc(-660px + 100vh)' : 'auto' }}>
        <div className="w-100">
          <div className="fw-bold mb-4"><FormattedMessage id="REPEAT_ON" />:</div>
          <div>
            {scheduler.repeat === SIGNAGE_MEDIA.CREATE_SIGNAGE.RECURRING
              ? (
                ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
                  .filter((_, idx) => scheduler.recurringDays[idx])
                  .map(day => <div key={day} className='mes-from-label-1 line-height-16 mb-4'><span>&bull;<span className="ml-20"><FormattedMessage id={day} /></span></span></div>)
              )
              : (
                <span>
                  &bull;<span key='daily' className="ml-20"><FormattedMessage id="DAILY" /></span>
                </span>
              )
            }
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default OverviewPanel;
